module.exports = __webpack_public_path__ + "img/crc-02.0caab2b4.jpg";